/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PaymentLinkPaymentStatus {
  PAID = 'paid',
  PENDING_PAYMENT = 'pending_payment',
}
